
import { BoardType } from '@/types/entities'
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

export default defineComponent({
  props: {
    title: {
      type: String,
      default: 'title'
    },
    submitText: {
      type: String,
      default: 'submit'
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  inject: ['list'],
  data () {
    return {
      form: {
        toListId: '',
        toBoardId: this.$route.params.boardId
      }
    }
  },
  mounted () {
    this.form.toListId = this.list._id
  },
  methods: {
    handleBoardChange (e: Event) {
      const target = e.target as HTMLInputElement
      this.form.toBoardId = target.value
      if (this.selectedBoard.lists.length) {
        this.form.toListId = this.selectedBoard.lists[0]._id
      }
    },
    handleListChange (e: Event) {
      const target = e.target as HTMLInputElement
      console.log(target.value)
      this.form.toListId = target.value
    }
  },
  computed: {
    ...mapState({
      workspace: 'workspace'
    }),
    allBoards () {
      return this.workspace.createdBoards.concat(this.workspace.invitedBoards)
    },
    selectedBoard () {
      return this.allBoards.find((board: BoardType) => board._id === this.form.toBoardId)
    }
  }
})
